export const AFFILIATION_FILTER_ALL = 'all';

export function mapAffiliationToOption(row) {
  if (!row) return null;
  const name = row.name || row.code;
  const city = row.city || '';
  return {
    id: row.id,
    value: row.code,
    code: row.code,
    label: name,
    city,
    shortLabel: city ? `${name} · ${city}` : name,
    isDefault: Boolean(row.is_default),
    isActive: row.is_active !== false
  };
}

export function mapAffiliationsToOptions(rows = []) {
  return rows.map(mapAffiliationToOption).filter(Boolean);
}

export function findAffiliationById(affiliations, id) {
  if (id == null) return null;
  return affiliations.find((a) => String(a.id) === String(id)) || null;
}

export function findAffiliationByCode(affiliations, code) {
  if (!code) return null;
  const normalized = String(code).trim().toUpperCase();
  return affiliations.find((a) => a.code === normalized) || null;
}

export function getDefaultAffiliation(affiliations = []) {
  return affiliations.find((a) => a.isDefault) || affiliations[0] || null;
}

export function resolveCompanyAffiliation(company, affiliations = []) {
  if (!company) return null;
  const byId = findAffiliationById(affiliations, company.affiliation_id);
  if (byId) return byId;
  const byCode = findAffiliationByCode(affiliations, company.affiliation);
  if (byCode) return byCode;
  if (company.affiliation_id || company.affiliation || company.affiliation_name) {
    return mapAffiliationToOption({
      id: company.affiliation_id,
      code: company.affiliation,
      name: company.affiliation_name || company.affiliation,
      city: company.affiliation_city,
      is_default: false,
      is_active: true
    });
  }
  return null;
}

export function getAffiliationShortLabelFromRef(ref) {
  if (!ref) return '—';
  return ref.shortLabel || ref.label || ref.code || '—';
}
